<div class="flex gap-M">
	<div class="flex-align-center search-bar-container bkg-white b-radius-9">
	<app-text-button type="default" color="primary" class="search-btn" panelClass="h-100-imp pad-0-imp"
					 (click)="openSearchPanel(input)">
		<div class="flex-center">
			<img src="assets/icons/search-md.svg" width="18" height="18" alt=""/>
		</div>
	</app-text-button>
	<div class="flex-space-between">
		<input #input class="search-input" [ngClass]="{'display-input': openSearch}"
			   [formControl]="$any(form.get('name'))" [placeholder]="openSearch ? ('page.application.table.filters.search'|translate) : ''">
		<app-text-button (click)="form.get('name')!.setValue('')" *ngIf="openSearch && searchValue" type="default" color="primary" panelClass="h-100-imp pad-0-imp" class="delete-text-button mr-xs">
			<div class="flex-center">
				<img src="assets/icons/close.svg" alt="">
			</div>
		</app-text-button>
		<div *ngIf="openSearch && !searchValue" style="width: 35px; height: 30px;">
		</div>
	</div>
	</div>
	<div class="flex-align-center filter-bar bkg-white b-radius-9 w-100">
		<div class="flex-align-center h-100 filter-btn-container" style="z-index: 2;">
			<app-dropdown [paddingX]="10" [paddingY]="10" #filterDropdown>
				<!-- Global search -->
				<app-text-input *ngIf="!filterSelected" [placeholder]="'page.application.table.filters.searchGlobal' | translate" class="flex w-100 mb-s" [input]="$any(form.get('globalSearch'))">
					<app-icon-button icon-suffix [img]="'assets/icons/close.svg'" size="xs" color="primary" [panelClass]="'img-size-30'"
									 *ngIf="form.get('globalSearch')!.value?.length > 0"
									 (click)="form.get('globalSearch')!.reset('')"></app-icon-button>
				</app-text-input>
				<!-- Global search results -->
				<div *ngIf="!filterSelected" style="width: 300px; max-height: 270px; overflow-y: auto;" class="flex-column gap-XS">
					<div *ngFor="let result of globalSearchResults" class="flex-align-center gap-XS pad-XS c-p b-radius-6 greyed-hover">
						<label class="custom-checkbox flex-align-center greyed-hover c-p b-radius-6 w-100 flex-space-between">
							<div class="text-overflow-ellipsis flex-align-center gap-XS" style="max-width: 240px">
								<img [src]="'assets/icons/filters/' + result.type + '.svg'" class="filter-grey" width="14" alt="">
								<span class="grey">{{ result.breadcrumb.top }}</span>
								<img width="6" src="assets/icons/arrow-right-black.svg" class="filter-grey">
								<div *ngIf="result.breadcrumb.middle" class="flex-align-center gap-XS">
									<span class="grey">{{ result.breadcrumb.middle }}</span>
									<img width="6" src="assets/icons/arrow-right-black.svg" class="filter-grey">
								</div>
								<span class="text-overflow-ellipsis">{{ result.breadcrumb.value }}</span>
							</div>
							<input type="checkbox"
								   [checked]="checkIfGlobalSearchResultSelected(result)"
								   (change)="onCheckboxChangeArray(result.type, result.item, $event, result.isParent, result.type === 'organization')"
								   style="margin-right: 8px;" />
						</label>
					</div>
					<div *ngIf="globalSearchResults.length === 0 && form.get('globalSearch')!.value?.length > 0" class="flex-center pad-S greyed-out">
						<span class="font-M fw-500 grey">{{'page.application.table.filters.noGlobalSearchResult'|translate}}</span>
					</div>
				</div>
				<div class="flex-column gap-XS" style="width: 300px;" *ngIf="!_loading && !!list && !filterSelected && form.get('globalSearch')!.value?.length <= 0">
					<!-- Criticality filter -->
					<div (click)="$event.stopPropagation();filterSelected = 'criticality'" class="flex-align-center flex-space-between pad-S greyed-hover c-p b-radius-6">
						<div class="flex-align-center gap-S">
							<img src="assets/icons/filters/criticality.svg" class="filter-primary">
							<span class="font-M fw-500 primary">{{'page.application.table.filters.criticality'|translate}}</span>
						</div>
						<div class="flex-align-center gap-M">
							<div *ngIf="form.get('criticality')!.value.length > 0" class="filter-active-bubble"></div>
							<img src="assets/icons/arrow-right-black.svg" class="filter-grey">
						</div>
					</div>
					<!-- Category filter -->
					<div (click)="$event.stopPropagation();filterSelected = 'category'" class="flex-align-center flex-space-between pad-S greyed-hover c-p b-radius-6">
						<div class="flex-align-center gap-S">
							<img src="assets/icons/filters/category.svg" class="filter-primary">
							<span class="font-M fw-500 primary">{{'page.application.table.filters.category'|translate}}</span>
						</div>
						<div class="flex-align-center gap-M">
							<div *ngIf="form.get('category')!.value.length > 0" class="filter-active-bubble"></div>
							<img src="assets/icons/arrow-right-black.svg" class="filter-grey">
						</div>
					</div>
					<!-- Type filter -->
					<div (click)="$event.stopPropagation();filterSelected = 'type'" class="flex-align-center flex-space-between pad-S greyed-hover c-p b-radius-6">
						<div class="flex-align-center gap-S">
							<img src="assets/icons/filters/hostingType.svg" class="filter-primary">
							<span class="font-M fw-500 primary">{{'page.application.table.filters.type'|translate}}</span>
						</div>
						<div class="flex-align-center gap-M">
							<div *ngIf="form.get('hostingType')!.value.length > 0" class="filter-active-bubble"></div>
							<img src="assets/icons/arrow-right-black.svg" class="filter-grey">
						</div>
					</div>
					<!-- Team filter -->
					<div (click)="$event.stopPropagation();filterSelected = 'organization'" class="flex-align-center flex-space-between pad-S greyed-hover c-p b-radius-6">
						<div class="flex-align-center gap-S">
							<img src="assets/icons/filters/organization.svg" class="filter-primary">
							<span class="font-M fw-500 primary">{{'page.application.table.filters.team'|translate}}</span>
						</div>
						<div class="flex-align-center gap-M">
							<div *ngIf="form.get('organization')!.value.length > 0" class="filter-active-bubble"></div>
							<img src="assets/icons/arrow-right-black.svg" class="filter-grey">
						</div>
					</div>
					<!-- Responsible filter -->
					<div (click)="$event.stopPropagation();filterSelected = 'account'" class="flex-align-center flex-space-between pad-S greyed-hover c-p b-radius-6">
						<div class="flex-align-center gap-S">
							<img src="assets/icons/filters/account.svg" class="filter-primary">
							<span class="font-M fw-500 primary">{{'page.application.table.filters.responsible'|translate}}</span>
						</div>
						<div class="flex-align-center gap-M">
							<div *ngIf="form.get('account')!.value.length > 0" class="filter-active-bubble"></div>
							<img src="assets/icons/arrow-right-black.svg" class="filter-grey">
						</div>
					</div>
					<!-- Status filter -->
					<div (click)="$event.stopPropagation();filterSelected = 'status'" class="flex-align-center flex-space-between pad-S greyed-hover c-p b-radius-6">
						<div class="flex-align-center gap-S">
							<img src="assets/icons/filters/status.svg" class="filter-primary">
							<span class="font-M fw-500 primary">{{'page.application.table.filters.status'|translate}}</span>
						</div>
						<div class="flex-align-center gap-M">
							<div *ngIf="form.get('status')!.value.length > 0" class="filter-active-bubble"></div>
							<img src="assets/icons/arrow-right-black.svg" class="filter-grey">
						</div>
					</div>
					<!-- Tags filter -->
					<div (click)="$event.stopPropagation();filterSelected = 'tag'" class="flex-align-center flex-space-between pad-S greyed-hover c-p b-radius-6">
						<div class="flex-align-center gap-S">
							<img src="assets/icons/filters/tag.svg" class="filter-primary">
							<span class="font-M fw-500 primary">{{'page.application.table.filters.tags'|translate}}</span>
						</div>
						<div class="flex-align-center gap-M">
							<div *ngIf="form.get('tag')!.value.length > 0" class="filter-active-bubble"></div>
							<img src="assets/icons/arrow-right-black.svg" class="filter-grey">
						</div>
					</div>
				</div>
				<div *ngIf="!filterSelected" class="hr-document mt-s"></div>
				<div *ngIf="!filterSelected" (click)="clearFilters(); filterDropdown.close();" class="radius-S pad-S flex-align-center gap-S greyed-hover c-p mt-s">
					<img src="assets/icons/trash-03.svg" class="filter-danger">
					<span class="danger font-M fw-500">{{'page.application.table.filters.clearAll'|translate}}</span>
				</div>
				<div *ngIf="!_loading && !!list && filterSelected" class="flex-column gap-S" style="width: 300px;">
					<div class="flex-align-center gap-S">
						<div (click)="getCurrentFilterSearchInput().reset('');filterSelected = undefined;" class="back-btn c-p greyed-hover flex-center" style="flex-shrink: 0">
							<img src="assets/icons/arrow-right-black.svg" class="filter-primary" height="12" alt="" style="transform: rotate(180deg) translateX(1px)">
						</div>
						<app-text-input [placeholder]="'page.application.table.filters.searchList.' + filterSelected | translate" *ngIf="filterSelected === 'organization' || filterSelected === 'account' || filterSelected === 'category' || filterSelected === 'tag'" class="flex w-100" [input]="getCurrentFilterSearchInput()">
							<app-icon-button icon-suffix [img]="'assets/icons/close.svg'" size="xs" color="primary" [panelClass]="'img-size-30'"
											 *ngIf="getCurrentFilterSearchInput().value?.length > 0"
											 (click)="getCurrentFilterSearchInput().reset('')"></app-icon-button>
						</app-text-input>
						<span *ngIf="filterSelected === 'criticality' || filterSelected === 'type' || filterSelected === 'status'">
							{{ 'page.application.table.filters.' + filterSelected | translate }}
						</span>
					</div>
					<div *ngIf="filterSelected === 'criticality'">
						<div *ngFor="let c of list.criticality" class="flex-align-center gap-XS pad-XS c-p b-radius-6 greyed-hover">
							<label class="custom-checkbox flex-align-center greyed-hover c-p b-radius-6 w-100 flex-space-between">
								<div class="flex-align-center gap-M" style="max-width: 260px;">
									<img src="assets/icons/criticality-{{c.toLowerCase()}}.svg" height="14" alt=""/>
									<span class="text-overflow-ellipsis">{{('page.appDetails.businessCriticality.' + c.toLowerCase())|translate}}</span>
								</div>
								<input type="checkbox"
									   [checked]="form.get('criticality')!.value.includes(c)"
									   (change)="onCheckboxChangeArray('criticality', c, $event)"
									   style="margin-right: 8px;" />
							</label>
						</div>
					</div>
					<div *ngIf="filterSelected === 'category'" style="max-height: 280px; overflow-y: auto;">
						<div *ngFor="let c of list.category" class="flex-align-center gap-XS pad-XS c-p b-radius-6 greyed-hover">
							<label class="custom-checkbox flex-align-center greyed-hover c-p b-radius-6 w-100 flex-space-between">
								<span class="text-overflow-ellipsis" style="max-width: 260px;">{{ c.name }}</span>
								<input type="checkbox"
									   [checked]="form.get('category')!.value.includes(c)"
									   (change)="onCheckboxChangeArray('category', c, $event)"
									   style="margin-right: 8px;" />
							</label>
						</div>
						<div *ngIf="list.category.length === 0" class="flex-center pad-S greyed-out">
							<span class="font-M fw-500 grey">{{'page.application.table.filters.noCategory'|translate}}</span>
						</div>
					</div>
					<div *ngIf="filterSelected === 'type'">
						<div *ngFor="let type of list.hostingType" class="flex-align-center gap-XS pad-XS c-p b-radius-6 greyed-hover">
							<label class="custom-checkbox flex-align-center greyed-hover c-p b-radius-6 w-100 flex-space-between">
								<span class="text-overflow-ellipsis" style="max-width: 260px;">{{('page.dashboard.typology.' + type)|translate}}</span>
								<input type="checkbox"
									   [checked]="form.get('hostingType')!.value.includes(type)"
									   (change)="onCheckboxChangeArray('hostingType', type, $event)"
									   style="margin-right: 8px;" />
							</label>
						</div>
					</div>
					<div *ngIf="filterSelected === 'organization'" style="max-height: 280px; overflow-y: auto;" class="flex-column gap-XS">
						<div *ngFor="let parent of list.organization" class="flex-column gap-XS">
							<label class="custom-checkbox flex-align-center greyed-hover pad-XS c-p b-radius-6 flex-space-between">
								<div (click)="$event.stopPropagation();$event.preventDefault();parent.organization.expanded = !parent.organization.expanded" class="flex-align-center gap-S" style="min-width: 80%;">
									<img src="assets/icons/arrow-right-black.svg" class="filter-grey" width="6" [style.rotate]="parent.organization.expanded ? '90deg' : '0deg'" alt=""/>
									<span class="text-overflow-ellipsis grey" style="max-width: 230px;">{{ parent.organization.name }}</span>
								</div>
								<input type="checkbox"
									   [checked]="areAllChildrenChecked(parent)"
									   (change)="onParentCheckChange(parent, $event)" />
							</label>
							<div [@expandCollapse]="parent.organization.expanded ? 'expanded' : 'collapsed'" style="padding-left: 15px;">
								<div style="border-left: 1px solid #DCDCE9;">
									<div *ngFor="let children of parent.children" class="flex-align-center gap-XS" style="padding-left: 10px;">
										<label class="pad-XS custom-checkbox flex-align-center greyed-hover c-p b-radius-6 w-100 flex-space-between">
											<div class="flex-align-center gap-S">
												<img [src]="'assets/icons/team_icon/' + (children.organization.icon || 'team') + '.svg'" class="filter-accent" width="14">
												<span class="text-overflow-ellipsis" style="max-width: 200px;">{{ children.organization.name }}</span>
											</div>
											<input type="checkbox"
												   [checked]="isChildChecked(children)"
												   (change)="onChildrenCheckChange(children, $event)"/>
										</label>
									</div>
									<div *ngIf="parent.children.length === 0" class="flex-center pad-S greyed-out">
										<span class="font-M fw-500 grey">{{'page.application.table.filters.noTeam'|translate}}</span>
									</div>
								</div>
							</div>
						</div>
						<div *ngIf="list.organization.length === 0" class="flex-center pad-S greyed-out">
							<span class="font-M fw-500 grey">{{'page.application.table.filters.noTeamGroup'|translate}}</span>
						</div>
					</div>
					<div *ngIf="filterSelected === 'account'" style="max-height: 280px; overflow-y: auto;">
						<div *ngFor="let a of list.account" class="flex-align-center gap-XS pad-XS c-p b-radius-6 greyed-hover">
							<label class="custom-checkbox flex-align-center greyed-hover c-p b-radius-6 w-100 flex-space-between">
								<app-display-user style="width: calc(100% - 40px);" [user]="a"></app-display-user>
								<input type="checkbox"
									   [checked]="form.get('account')!.value.includes(a)"
									   (change)="onCheckboxChangeArray('account', a, $event)"
									   style="margin-right: 8px;" />
							</label>
						</div>
						<div *ngIf="list.account.length === 0" class="flex-center pad-S greyed-out">
							<span class="font-M fw-500 grey">{{'page.application.table.filters.noAccount'|translate}}</span>
						</div>
					</div>
					<div *ngIf="filterSelected === 'status'" style="max-height: 280px; overflow-y: auto;">
						<div *ngFor="let s of list.status" class="flex-align-center gap-XS pad-XS c-p b-radius-6 greyed-hover">
							<label class="custom-checkbox flex-align-center greyed-hover c-p b-radius-6 w-100 flex-space-between">
								<app-display-app-status style="max-width: 260px;" class="text-overflow-ellipsis" [appStatus]="s"></app-display-app-status>
								<input type="checkbox"
									   [checked]="form.get('status')!.value.includes(s)"
									   (change)="onCheckboxChangeArray('status', s, $event)"
									   style="margin-right: 8px;" />
							</label>
						</div>
					</div>
					<div *ngIf="filterSelected === 'tag'" style="max-height: 280px; overflow-y: auto;">
						<div *ngFor="let t of list.tag" class="flex-align-center gap-XS pad-XS c-p b-radius-6 greyed-hover">
							<label class="custom-checkbox flex-align-center greyed-hover c-p b-radius-6 w-100 flex-space-between">
								<span class="text-overflow-ellipsis" style="max-width: 260px;">{{ t.name }}</span>
								<input type="checkbox"
									   [checked]="form.get('tag')!.value.includes(t)"
									   (change)="onCheckboxChangeArray('tag', t, $event)"
									   style="margin-right: 8px;" />
							</label>
						</div>
						<div *ngIf="list.tag.length === 0" class="flex-center pad-S greyed-out">
							<span class="font-M fw-500 grey">{{'page.application.table.filters.noTag'|translate}}</span>
						</div>
					</div>
					<div *ngIf="filterSelected" class="hr-document"></div>
					<div *ngIf="filterSelected" (click)="clearSpecificFilter(filterSelected);" class="radius-S pad-S flex-align-center gap-S greyed-hover c-p">
						<img src="assets/icons/trash-03.svg" class="filter-danger">
						<span class="danger font-M fw-500">{{'page.application.table.filters.clearList.' + filterSelected|translate}}</span>
					</div>
				</div>
			</app-dropdown>
			<app-text-button type="default" color="primary" class=filter-btn panelClass="h-100-imp"
							 [badge]="activeFilters.length > 0 ? activeFilters.length : undefined"
							 [disabled]="!list" [loading]="_loading"
							 [dropdownTrigger]="filterDropdown">
				<div class="flex-center gap-S">
					<span>{{'page.application.table.filters.button'|translate}}</span>
					<img src="assets/icons/filter-lines.svg" width="16" height="16" alt=""/>
				</div>
			</app-text-button>
		</div>
		<div class="flex-align-center w-100 h-100 border-light-grey-left pad-left-S filter-panel" style="z-index: 1; transition: 0s;" #responsiveFilterPanel
			 [ngClass]="{'filter-panel-open': openFilters}" [style.top.px]="(responsiveFilterPanel.offsetHeight / 2) - 26.5" >
			<div class="flex-wrap flex-align-center h-100 gap-S" style="width: calc(100% - 30px); margin: 12px 0;"
				 [ngStyle]="{'max-height': openFilters ? '100%' : '28px'}" [ngClass]="{'overflow-hidden': !openFilters}">
				@for (filter of activeFilters; track filter.id) {
					<div class="flex-center horizontal-bar-L bkg-light-grey-2 pad-0-M gap-M">
						<span class="font-S fw-500">{{filter.value}}</span>
						<img class="filter-grey c-p" src="assets/icons/close.svg" width="9" height="9" alt="" style="z-index: 9999"
							 (click)="removeFilter(filter)"/>
					</div>
				}
			</div>
			<div class="flex-center b-radius-right-9 c-p" style="width: 30px; height: 30px;"
				 (click)="openFilters = !openFilters" *ngIf="activeFilters.length">
				<img src="assets/icons/arrow-right-black.svg" class="rotate-90 filter-grey" height="12" alt="">
			</div>
		</div>
	</div>
</div>
